export default (phoneNumber) => {
  if (!phoneNumber) return null
  return 'tel:' + phoneNumber.replace(/[^\d]/g, '').replace(/^0/, '+44')
}
